const apiURL = process.env.VUE_APP_GRAPHQL_ENDPOINT || "https://nierowne-traktowanie.put.poznan.pl/graphql"
const eLoginClientId = process.env.VUE_APP_ELOGINCLIENTID || "nierowne-traktowanie.esys.put.poznan.pl"
const sentryDSN = process.env.VUE_APP_SENTRY_DSN || null

export {apiURL, eLoginClientId, sentryDSN}
